import { mergeTerms } from './semantic';

export const MAX_ITEM_TEXT_LENGTH = 240;
export const MAX_ITEM_ALIASES = 30;
export const MAX_ALIASES_INPUT_LENGTH = 4_000;
export const MAX_SYNC_PHOTO_BASE64_LENGTH = 1_500_000;

export function normalizeItemValues(values: { name: string; locationNote: string; locationGroup?: string; synonyms: string[] }) {
  const name = values.name.trim();
  const locationNote = values.locationNote.trim();
  const locationGroup = locationNote ? (values.locationGroup?.trim() || locationNote) : '';
  if (!name) throw new Error('Add an item name before saving.');
  if (name.length > MAX_ITEM_TEXT_LENGTH) throw new Error(`Keep the item name under ${MAX_ITEM_TEXT_LENGTH} characters.`);
  if (locationNote.length > MAX_ITEM_TEXT_LENGTH) throw new Error(`Keep the location under ${MAX_ITEM_TEXT_LENGTH} characters.`);
  if (locationGroup.length > MAX_ITEM_TEXT_LENGTH) throw new Error(`Keep the gallery section under ${MAX_ITEM_TEXT_LENGTH} characters.`);

  const synonyms = mergeTerms(values.synonyms);
  if (synonyms.length > MAX_ITEM_ALIASES) throw new Error(`Use no more than ${MAX_ITEM_ALIASES} other names.`);
  if (synonyms.some((synonym) => synonym.length > MAX_ITEM_TEXT_LENGTH)) {
    throw new Error(`Keep each other name under ${MAX_ITEM_TEXT_LENGTH} characters.`);
  }
  return { name, locationNote, locationGroup, synonyms };
}
